import React from 'react';
import { components, DropdownIndicatorProps, GroupBase } from 'react-select';
import classNames from 'classnames';

import { Icon, IconSize } from '../../Icon';
import { Spinner } from '../../Spinner';

import styles from './DropdownComponents.module.scss';
// ---

function DropdownIndicator<T, IsMulti extends boolean, Group extends GroupBase<T>>(
  props: DropdownIndicatorProps<T, IsMulti, Group>,
): JSX.Element {
  const isItemLoading = (props.selectProps.menuIsOpen && props.selectProps.isLoading);

  return (
    <components.DropdownIndicator {...props}>
      {isItemLoading ? (
        <Spinner size={IconSize.SMALL} />
      ) : (
        <Icon icon="chevron-down"
              size={props.selectProps.indicatorSize}
              className={classNames(styles.dropdownIcon, {
                [styles.rotated]: Boolean(props.selectProps.menuIsOpen),
              })} />
      )}
    </components.DropdownIndicator>
  );
}

export default DropdownIndicator;
